module.exports = "<p>\n  promotiondetails-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-grid/promotiondetails-grid.component.html
// module id = ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-grid/promotiondetails-grid.component.html
// module chunks = main